
import React from 'react'
import DefaultButton from '../../components/DefaultButton'
import { useModal } from '../../contexts/ModalContext'

export default function LocationCTA() {
  const {openQueryModal} = useModal();
  return (
    <>
      <section className="home-cta-area location-cta">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="home-cta-box">
                <div className="row align-items-center">
                  <div className="col-lg-8 col-md-8">
                    <span>Connect with Our Team</span>
                    <h2 className="heading">Start Your Digital Transformation Journey With Dox and box Today.</h2>
                  </div>
                  <div className="col-lg-4 col-md-4 text-end">
                    <DefaultButton onClick={openQueryModal} text="Book Consultation" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}




